





































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as data from "../../_store/data.module";
import Questionario from "../Questionario.vue";
import { bus } from "../../main";

@Component({
  components: {
    Questionario
  }
})
export default class QuestonaroDialog extends Vue {
  @Prop() info!: any;
  @Prop() dialogParams!: any;
  @Prop() activityType!: string;
  @Prop() tipoQuestionario!: string;

  private dialog: boolean;
  private statusQuestionario: number;
  private allowQuestionario: boolean;

  constructor() {
    super();
    this.dialog = false;
    this.statusQuestionario = 0;
    this.allowQuestionario = false;
  }

  close() {
    this.dialog = false;
  }

  created() {
    var currentDay = new Date();
    var dataFine = new Date(this.info.dataFineAttivita);
    var payload = {
      idRichiesta: this.info.idRichiesta,
      activityType: this.activityType,
      tipoQuestionario: this.tipoQuestionario
    };
    data.dispatchStatusQuestionario(this["$store"], payload).then(result => {
      if (result !== undefined) {
        this.statusQuestionario = result;
      }
      this.allowQuestionario = currentDay >= dataFine;
    });

    bus.$on("closeQuestionarioDialog", () => {
      if (this.tipoQuestionario === "questionarioWorkshopAllievo") {
        bus.$emit("loadAttivitaIstituto");
      }
      this.close();
    });
  }
}
